import { Component, HostListener, inject, output } from '@angular/core';

import {
  CancelButtonComponent,
  CloseIconButtonComponent,
  OutlinedSubmitButtonComponent,
} from '@sandbox-platform/shared-ui';

import { OrganizationSelectionInputComponent } from '../../../../shared/components';
import {
  PAYMENT_METHOD_LABELS,
  PAYMENT_TYPE_LABELS,
} from '../../../../types/commission-payment.types';
import { CommissionPaymentFilterDisplayStore } from '../+state';

@Component({
  standalone: true,
  imports: [
    CancelButtonComponent,
    CloseIconButtonComponent,
    OrganizationSelectionInputComponent,
    OutlinedSubmitButtonComponent,
  ],
  selector: 'lib-commission-payment-filter-dialog',
  templateUrl: './commission-payment-filter-dialog.component.html',
})
export class CommissionPaymentFilterDialogComponent {
  protected readonly filterDisplayStore = inject(
    CommissionPaymentFilterDisplayStore
  );

  protected readonly paymentTypeOptions = [
    { value: 'all' as const, label: 'All types' },
    { value: 'payment' as const, label: PAYMENT_TYPE_LABELS.payment },
    { value: 'reversal' as const, label: PAYMENT_TYPE_LABELS.reversal },
    { value: 'adjustment' as const, label: PAYMENT_TYPE_LABELS.adjustment },
  ];

  protected readonly paymentMethodOptions = [
    { value: 'all' as const, label: 'All methods' },
    {
      value: 'bank_transfer' as const,
      label: PAYMENT_METHOD_LABELS.bank_transfer,
    },
    { value: 'check' as const, label: PAYMENT_METHOD_LABELS.check },
    { value: 'other' as const, label: PAYMENT_METHOD_LABELS.other },
  ];

  dialogCancel = output<void>();
  apply = output<void>();

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.filterDisplayStore.isDialogOpen()) {
      this.onCancel();
    }
  }

  protected onApply(): void {
    this.apply.emit();
  }

  protected onCancel(): void {
    this.filterDisplayStore.closeDialog();
    this.dialogCancel.emit();
  }

  protected onClear(): void {
    this.filterDisplayStore.resetDraft();
  }
}
